import { render, staticRenderFns } from "./newCustomer.vue?vue&type=template&id=29f793f0&"
import script from "./newCustomer.vue?vue&type=script&lang=js&"
export * from "./newCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports